// Turks (tr-TR), kaartApp: zelfde vorm als kaartApp.nl.ts (golf 3-integratie). De stappen voor
// Google, Outlook en de iPhone noemen de knoppen zoals die apps ze in het Turks tonen.
export const appPlacesTr = {
    placeholder: 'Bir yer yaz, örneğin Yüzme havuzu De Vliet',
    hintSearch: 'En az 3 harf yaz: Google Haritalar’dan öneriler gelir.',
    searching: 'Aranıyor...',
    suggestions: 'Öneriler',
    noResults: 'Bir şey bulunamadı. Yeri kendin de yazabilirsin.',
    attribution: 'Google Haritalar önerileri',
    chosen: 'Seçilen yer',
    change: 'Başka bir yer',
    remove: 'Yeri kaldır',
    typedOnly: 'Yalnızca metin (haritada yer yok)',
    notConfigured: 'Google Haritalar ile arama bu sunucuda henüz açık değil. Yeri kendin yaz.',
    unavailable: 'Google Haritalar şu an yanıt vermiyor. Yeri kendin yaz veya biraz sonra tekrar dene.',
    tooMany: 'Kısa sürede çok fazla arama yapıldı. {minutes} dakika sonra tekrar dene.',
    saveFailed: 'Yer kaydedilmedi (etkinlik kaydedildi). Biraz sonra tekrar dene.',
    travelTitle: 'Yolculuk süresi',
    travelAuto: '{minutes} dk {mode}',
    travelAutoHint: 'Ailenin bulunduğu yerden hesaplandı. Aşağıda kendin bir süre seçersen, o geçerli olur.',
    travelPending: 'Kaydederken hesaplanacak.',
    travelStatus: {
        no_origin: 'Önce ailenin bulunduğu yeri seç, sonra uygulama yolculuk süresini hesaplar.',
        no_route: 'Google Haritalar bu yere bir yol bilmiyor.',
        not_configured: 'Yolculuk süresi hesaplama bu sunucuda henüz açık değil.',
        unavailable: 'Yolculuk süresi şu an hesaplanamadı. Bir sonraki kayıtta tekrar deneriz.',
        module_off: 'Yolculuk süresi kapalı (Ayarlar · Modüller).',
    },
    modeTitle: 'Nasıl gidiyorsunuz?',
    modeUsual: 'Her zamanki gibi',
    modes: { drive: 'Araba', bicycle: 'Bisiklet', walk: 'Yürüyerek' },
    modeWith: { drive: 'arabayla', bicycle: 'bisikletle', walk: 'yürüyerek' },
    autoOption: 'Otomatik ({minutes} dk)',
    // fix/afspraakformulier: schakelaar bij "Waar" (onthouden op dit apparaat, per gebruiker).
    google: 'Google Haritalar ile ara',
    googleOn: 'Açık: öneriler sunucumuz üzerinden gelir (Google Haritalar).',
    googleOff: 'Kapalı: yeri kendin yazarsın. Google’a hiçbir şey gitmez.',
    moduleOff: 'Yer arama kapalı (Ayarlar · Modüller). Yeri normal yaz.',
};
export const appTravelTr = {
    title: 'Yolculuk süresi ve yerler',
    intro: '"Nerede" alanında önerilerden bir yer seç, uygulama ne kadar yolda olacağını hesaplar. Tablet de sana ne zaman yola çıkman gerektiğini söyler.',
    modeTitle: 'Genelde böyle gideriz',
    modeHint: 'Her etkinlik için başka bir şey seçebilirsin.',
    saved: 'Kaydedildi',
    originMissing: 'Ailenin bulunduğu yer henüz eksik. Çıkış noktası olmadan yolculuk süresi olmaz.',
    originLink: 'Yer seç',
    googleOff: 'Google Haritalar bu sunucuda henüz açık değil: öneriler ve yolculuk süresi çalışmaz. "Nerede" alanına yazmak her zaman çalışır.',
    privacyTitle: 'Google’a ne gidiyor?',
    privacyBody: 'Yalnızca "Nerede" alanına yazdığın şey, oturduğun yerin çevresinde kaba bir konum (yaklaşık 5 km) ve yolculuk süresi için yaklaşık bir kilometre hassasiyetinde çıkış noktası. Asla isimler, e-posta adresleri veya kimin gittiği değil. Hesabı Google bizim için yapar; tablet ve tarayıcın Google ile asla konuşmaz.',
    settingsBody: 'Araba, bisiklet veya yürüyerek; Google’a ne gidiyor',
};
export const appFeedsTr = {
    title: 'Takvim bağla',
    settingsBody: 'Etkinliklerin Google’da, Outlook’ta veya iPhone’da da',
    intro: 'Etkinliklerini Google Takvim’e, Outlook’a veya iPhone’una da koy. Planlama yeri pano olarak kalır: orada değiştirdiğin şey buraya geri gelmez.',
    oneWay: 'Tek yönlü',
    inbound: 'Tersi mi, okulun veya sporun takvimini içeri almak mı? Bunu Takvimler bölümünde yaparsın.',
    inboundLink: 'Takvimlere git',
    forWho: 'Kimin için',
    lastFetchedNever: 'henüz hiç',
    settingsLabel: 'Bu bağlantının ayarları',
    newTitle: 'Yeni bağlantı',
    whose: 'Hangi etkinlikler?',
    whole: 'Bütün aile',
    memberOnly: 'Yalnızca {name}',
    busyOnly: 'Yalnızca "meşgul" göster',
    busyOnlyHint: 'Başkaları bir şey olduğunu görür, ne olduğunu değil. İş takvimi için kullanışlı.',
    faith: 'İnancımızla ilgili etkinlikler de (Namaz veya Cami dersi gibi)',
    faithHint: 'Varsayılan olarak kapalı: o zaman Google, Microsoft veya Apple da okur.',
    create: 'Bağlantı oluştur',
    creating: 'Biraz bekle...',
    created: 'Bağlantın hazır',
    copy: 'Bağlantıyı kopyala',
    copied: 'Kopyalandı',
    copyFailed: 'Kopyalama olmadı. Bağlantıyı seç ve kendin kopyala.',
    openApple: 'Takvim’de aç (iPhone, Mac)',
    linkOnce: 'Bağlantıyı şimdi takvim uygulamana yapıştır. Onu okunabilir şekilde saklamıyoruz: sonra kolayca yenisini oluşturursun.',
    linkLabel: 'Senin bağlantın',
    listTitle: 'Bağlantıların',
    empty: 'Henüz bağlantı yok. Yukarıda bir tane oluştur.',
    forWhole: 'Bütün aile',
    forMember: '{name}',
    badgeBusy: 'Yalnızca meşgul',
    badgeFaith: 'İnançla birlikte',
    lastFetched: 'Son alınma: {when}',
    neverFetched: 'Henüz bir takvim uygulaması tarafından alınmadı',
    hiddenLink: 'Bağlantının kendisini yalnızca oluştururken görürsün.',
    renew: 'Yeni bağlantı',
    renewTitle: 'Yeni bağlantı oluşturulsun mu?',
    renewBody: 'Eski bağlantı bundan sonra çalışmaz. Yeni bağlantıyı takvim uygulamana yeniden yapıştır.',
    renewConfirm: 'Yeni bağlantı oluştur',
    revoke: 'Geri çek',
    revokeTitle: 'Bağlantı geri çekilsin mi?',
    revokeBody: 'Bu bağlantı hemen çalışmaz olur. Etkinlikler bir sonraki yenilemede diğer takvimden kaybolur.',
    revokeConfirm: 'Geri çek',
    revoked: 'Bağlantı geri çekildi',
    cancel: 'Vazgeç',
    tooMany: 'Aile başına en fazla 20 bağlantı. Önce eski bir bağlantıyı geri çek.',
    howTitle: 'Nasıl eklenir',
    google: {
        title: 'Google Takvim',
        steps: [
            'Bir bilgisayarda Google Takvim’i aç (calendar.google.com).',
            'Solda "Diğer takvimler" yanındaki artı işaretine tıkla.',
            '"URL’den" seçeneğini seç.',
            'Bağlantıyı yapıştır ve "Takvim ekle"ye tıkla.',
        ],
    },
    outlook: {
        title: 'Outlook ve Microsoft 365',
        steps: [
            'Web’de Outlook’u aç (outlook.office.com veya outlook.live.com).',
            'Takvim’e git ve "Takvim ekle"yi seç.',
            '"Web’den abone ol"u seç.',
            'Bağlantıyı yapıştır, takvime bir ad ver ve "İçeri aktar"a tıkla.',
        ],
    },
    apple: {
        title: 'iPhone ve iCloud',
        steps: [
            'iPhone’unda Ayarlar’ı aç.',
            'Uygulamalar’a, sonra Takvim’e, sonra Takvim Hesapları’na, sonra "Hesap Ekle"ye dokun. (Eski bir iPhone’da: Takvim, sonra Hesaplar.)',
            '"Diğer"e ve sonra "Takvim Aboneliği Ekle"ye dokun.',
            'Bağlantıyı yapıştır, "Sonraki"ye ve "Kaydet"e dokun.',
        ],
    },
    refreshNote: 'Açık konuşalım: Google Takvim böyle bir bağlantıyı yalnızca birkaç saatte bir alır, bazen daha da seyrek. Outlook ve iPhone daha sık alır. Yani bir değişiklik her yerde hemen görünmez; panoda ise hemen görünür.',
    privacyNote: 'Özel etkinlikler asla gönderilmez. Bağlantıya sahip olan herkes etkinlikleri okuyabilir: onu başkalarıyla paylaşma, ortalıkta dolaşıyorsa geri çek.',
    icsBusy: 'Meşgul',
    /** Een bijzondere dag van meer dagen in de .ics. */
    icsDayOf: '{title} ({count} günün {index}. günü)',
};
//# sourceMappingURL=kaartApp.tr.js.map